'use strict';

import * as Props from '../Props';

const angular = require('angular');

const ViewAssociations = {
    Basic: {
        'ControlType': 'ViewAssociations',
        'Label': {
            name: 'label',
            selectedValue: 'View Associations',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'Field Name': Props.getFieldName('ViewAssociations'),
        'Data Field Name': Props.getDataFieldName('ViewAssociations'),
        'Assoc Type': {
            name: 'assoc.type',
            type: 'dd',
            options: [
                {
                    value: '',
                    key: 'Please select'
                },
                {
                    value: 'Files',
                    key: 'Files'
                }, {
                    value: 'Apps',
                    key: 'Apps'
                }],
            selectedValue: '',
        },
        'Message Type': {
            name: 'msg.type',
            type: 'dd',
            options:
                [{
                    value: '',
                    key: 'Please select'
                },
                {
                    value: '0',
                    key: 'All messages'
                }, {
                    value: '1',
                    key: 'Current message'
                },
                ],
            selectedValue: '',
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
    },
    Association: {
        'AddSetup': {
            type: "button",
            title: "Add Setup",
            selectedValue: "1",
            icon: "fa fa-plus",
            onClickFunction: "addcolumnName",
            clicked: false
        },
        'Files': {
            'Parameters': {
                type: "table",
                list: [
                    {
                        value: {
                            selectedValue: "",
                            type: "dropdown",
                            inputWidth: "width:100px;"
                        },
                        sorting: {
                            selectedValue: "",
                            type: "radio",
                        }
                    }
                ],
                hidden: true
            },
            'table': {
                type: "table",
                default: "datasource",
                list: [
                    {
                        id: 1,
                        Value: {
                            name: {
                                "id": "2",
                                "fieldName": "document_ref",
                                "colDisplayName": "Doc Ref",
                                "dataType": "text",
                                "function": "openDocument",
                                "widthOfColumn": 125,
                                "isSortSupported": true,
                                "isCustomAttributeColumn": false,
                            },
                            type: "dropdown",
                            inputWidth: "width:100px;",
                            disable: false,
                        },
                        Sorting: {
                            name: 'sorting',
                            type: 'radio',
                            selectedValue: '',
                            disable: false,
                            list: [
                                {
                                    name: 'Descending',
                                    value: '1'
                                },
                                {
                                    name: 'Ascending',
                                    value: '0'
                                },
                            ]
                        },
                        showUpdateOptions: true
                    }
                ],
                hidden: true
            },
            hidden: true
        },
        'Apps': {
            'Parameters': {
                type: "table",
                list: [
                    {
                        value: {
                            selectedValue: "",
                            type: "dropdown",
                            inputWidth: "width:100px;"
                        },
                        sorting: {
                            selectedValue: "",
                            type: "radio",
                        }
                    }
                ],
                hidden: true
            },
            'table': {
                type: "table",
                default: "datasource",
                list: [
                    {
                        id: 1,
                        Value: {
                            name: {
                                "id": "5",
                                "fieldName": "formDisplayId",
                                "colDisplayName": "ID",
                                "dataType": "text",
                                "function": "openApps",
                                "widthOfColumn": 125,
                                "isSortSupported": true,
                                "isCustomAttributeColumn": false,
                            },
                            type: "dropdown",
                            inputWidth: "width:100px;",
                            disable: false,
                        },
                        Sorting: {
                            name: 'sorting',
                            type: 'radio',
                            selectedValue: '',
                            disable: false,
                            list: [
                                {
                                    name: 'Descending',
                                    value: '1'
                                },
                                {
                                    name: 'Ascending',
                                    value: '0'
                                },
                            ]
                        },
                        showUpdateOptions: true
                    }
                ],
                hidden: true
            },
            hidden: true
        },
        'Name': {
            selectedValue: 'Add/Edit Fields',
            hidden: true
        },
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '1',
                    max: '30',
                    default: 16
                },
            }
        },
        'Name': {
            selectedValue: 'label.style',
            hidden: true
        }
    },
    ControlStyle: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '14',
                    max: '20',
                    default: 16
                },
            }
        },
        'Name': {
            selectedValue: 'control.style',
            hidden: true
        }
    },
    Advanced: {
        'Reportable': angular.copy(Props.Reportable),
        'Name': {
            selectedValue: 'Advanced',
            hideSection: false,
            hidden: true
        },
    },
   
};



export default ViewAssociations;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/ViewAssociations.ts